(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-ulti-pdp-tabs]').forEach(group => {
      if (group.dataset.ready) return;
      group.dataset.ready = 'true';
      const tabs = [...group.querySelectorAll('[data-tab]')];
      const panels = [...group.querySelectorAll('[data-panel]')];
      group.querySelector('[data-tab-list]').setAttribute('role', 'tablist');
      function select(name, focus = false) {
        tabs.forEach(tab => {
          const active = tab.dataset.tab === name;
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          if (active && focus) tab.focus();
        });
        panels.forEach(panel => {
          panel.setAttribute('role', 'tabpanel');
          panel.tabIndex = 0;
          panel.hidden = panel.dataset.panel !== name;
        });
      }
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab.dataset.tab));
        tab.addEventListener('keydown', event => {
          const next = { ArrowRight: (index + 1) % tabs.length, ArrowLeft: (index + tabs.length - 1) % tabs.length, Home: 0, End: tabs.length - 1 }[event.key];
          if (next === undefined) return;
          event.preventDefault();
          select(tabs[next].dataset.tab, true);
        });
      });
      const hash = () => { if (location.hash === '#specs') select('specs'); };
      const anchor = event => { if (event.target.closest('a[href="#specs"]')) select('specs'); };
      select(location.hash === '#specs' ? 'specs' : tabs[0].dataset.tab);
      window.addEventListener('hashchange', hash);
      document.addEventListener('click', anchor);
      const unload = event => {
        if (!event.target.contains(group)) return;
        window.removeEventListener('hashchange', hash);
        document.removeEventListener('click', anchor);
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
